import React from 'react'
import { storiesOf } from '@storybook/react'

import StoreItemList from 'components/StoreItemList'
import { StoreProduct, IStoreProduct } from 'protos'

const products = Array(10).fill(null).map((_, i) => {
  return StoreProduct.create({
    type: StoreProduct .Type.COIN,
    level: 3,
    price: [{ currency: 0, value: 9999 }],
    quantity: 9999,
    productId: `${i}`,
  } as IStoreProduct)
})

storiesOf('StoreItemList', module)
  .add('default', () => (
    <StoreItemList products={products} />
  ))
